import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-state-box-headline',
    templateUrl: './state-box-headline.component.html',
    styleUrls: ['./state-box-headline.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class StateBoxHeadlineComponent {

    constructor() {
    }

}
